export default __webpack_public_path__ + "static/media/interactivity.0b7183be.svg";